import { fetchEntities } from './sort/client/fetch-entities'
import type { FetchCardsSlugReturn } from './use-fetch-cards-helper'
import * as Sentry from '@sentry/nextjs'

export const fetchCardsSlugSimple = async (
  slugs: [string] & string[],
  callback: (result: FetchCardsSlugReturn) => void,
): Promise<void> => {
  try {
    const entities = await fetchEntities(slugs)
    if (entities && !entities.error) {
      callback({ cards: entities.cards, isFetching: false, error: false })
    } else {
      callback({ cards: [], isFetching: false, error: true })
    }
  } catch (error) {
    Sentry.captureException(error)
    callback({ cards: [], isFetching: false, error: true })
  }
}
